import { useState } from 'react';
import { Stack, TextField } from '@mui/material';
import { ConfirmDialog } from '../common/dialogs/ConfirmDialog';

const RenameAgentDialog = ({
  initialName,
  isOpen,
  onConfirm,
  closeDialog,
}: {
  initialName: string;
  isOpen: boolean;
  onConfirm: (name: string) => Promise<void>;
  closeDialog: () => void;
}) => {
  const [updatedName, setUpdateName] = useState(initialName);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const charLength = updatedName.length;
  const isValid = charLength > 0;

  const onConfirmHandler = async () => {
    setIsSubmitting(true);
    await onConfirm(updatedName);
    setIsSubmitting(false);
    closeDialog();
  };

  const onKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' && isValid) {
      event.stopPropagation();
      onConfirmHandler();
    }
  };

  return (
    <ConfirmDialog
      isOpen={isOpen}
      titleVariant="h3"
      title="Rename Agent"
      confirmText="Done"
      onConfirm={onConfirmHandler}
      handleClose={closeDialog}
      onCancel={closeDialog}
      dialogContentSx={{ width: '554px', marginTop: '8px' }}
      disableConfirmButton={!isValid || isSubmitting}
      disableAutoFocus={true}
      disableEnforceFocus={true}
      dialogActionsSx={{padding: '8px 16px 24px 16px'}}
    >
      <Stack alignItems="flex-end" spacing={0.5} >
        <TextField
          fullWidth
          autoFocus
          placeholder="Enter agent name"
          value={updatedName}
          onKeyDown={onKeyDown}
          onChange={(e) => {
            setUpdateName(e.target.value);
          }}
          inputProps={{ maxlength: 150 }}
        />
      </Stack>
    </ConfirmDialog>
  );
};

export default RenameAgentDialog;
